"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SVG_S3_PREFIX = void 0;
var _react = _interopRequireDefault(require("react"));
var _shared = require("../../utils/shared.utils");
var SVG_S3_PREFIX = exports.SVG_S3_PREFIX = 'https://public-content.honeybook.com/sys/svg';
// TODO is there a way to make sure devs use this comp for svgs stored in our repo
// and not for svgs stored in cloudinary?

var HBSVG = function HBSVG(_ref) {
  var path = _ref.path,
    width = _ref.width,
    height = _ref.height,
    className = _ref.className,
    alt = _ref.alt;
  var _path = path;
  if (!(0, _shared.isUrl)(path)) {
    // if relative path, add svg prefix
    _path = SVG_S3_PREFIX + path;
  }
  return /*#__PURE__*/_react["default"].createElement("img", {
    src: _path,
    width: width,
    height: height,
    className: className,
    alt: alt || path
  });
};
var _default = exports["default"] = HBSVG;
//# sourceMappingURL=HBSVG.js.map